"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    collapsed: false,
    collapsedGroups: ['after_ratings', 'after_addtocart', 'before_desc'],
    items: [1, 2, 3],
    itemsById: {
      1: {
        id: 1,
        link: '#',
        img: 'https://placehold.it/500x80?text=Content+or+Banner+can+turn+on/off+on+product+pages',
        alt: 'Below product ratings on product page',
        text: '',
        heading: '',
        btn: '',
        collapsed: false,
        type: 'banner',
        position: 'after_ratings'
      },
      2: {
        id: 2,
        link: '#',
        img: 'https://placehold.it/500x80?text=Content+or+Banner+can+turn+on/off+on+product+pages',
        alt: 'Below add to cart button on product page',
        text: '',
        heading: '',
        btn: '',
        collapsed: false,
        type: 'banner',
        position: 'after_addtocart'
      },
      3: {
        id: 3,
        link: '#',
        img: 'https://placehold.it/1920x250?text=Content+or+Banner+can+turn+on/off+on+product+pages',
        alt: 'Above description tabs on product page',
        text: '',
        heading: '',
        btn: '',
        collapsed: false,
        type: 'banner',
        position: 'before_desc'
      }
    },
    itemNextId: 4
  };
}